module.exports = __webpack_public_path__ + "img/pulso-amarillo.8a3551a4.png";